import { render, staticRenderFns } from "./leaveStastic.vue?vue&type=template&id=590825ea&scoped=true"
import script from "./leaveStastic.vue?vue&type=script&lang=js"
export * from "./leaveStastic.vue?vue&type=script&lang=js"
import style0 from "./leaveStastic.vue?vue&type=style&index=0&id=590825ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590825ea",
  null
  
)

export default component.exports